import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC, useState } from "react";
import { Control } from "ol/control";
import { Basemaps } from "../enums";
import mammaImage from "../../img/basemaps/mamma.png";
import ortoImage from "../../img/basemaps/orto2.png";

export const Basemap: FC<{ this: Control; onToggle: CallableFunction }> = (props) => {
    const [mapId, setMapId] = useState<Basemaps>(Basemaps.Orto);

    const onClick = () => {
        const newMap = mapId === Basemaps.Mamma ? Basemaps.Orto : Basemaps.Mamma;
        setMapId(newMap);
        props.onToggle(newMap);
    };

    return (
        <button onClick={onClick} title={"Mainīt pamatkarti"}>
            <img src={mapId === Basemaps.Mamma ? mammaImage : ortoImage} />
        </button>
    );
};

export class BasemapButton extends Control {
    constructor(toggleBasemap: CallableFunction) {
        const element = document.createElement("div");
        element.id = "basemap-toggle";
        element.className = "conexus-form-button ol-unselectable ol-control";
        super({
            element
        });
        ReactDOM.render(<Basemap this={this} onToggle={toggleBasemap} />, element);
    }
}
